import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { ThemeProvider } from './context/ThemeContext';
import GlobalStyles from './GlobalStyles';
import PageTransition from './components/PageTransition';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatwootWidget from './components/ChatwootWidget';

import Home from './pages/Home';
import Solucoes from './pages/Solucoes';
import ProductDetail from './pages/ProductDetail';
import Planos from './pages/Planos';
import PlanosFazendaLeiteira from './pages/PlanosFazendaLeiteira';
import Contact from './pages/Contact';
import { PoliticaPrivacidade } from './pages/PoliticaPrivacidade';
import { TermosUso } from './pages/TermosUso';

import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <GlobalStyles />

        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Navbar />

          <main style={{ flex: 1 }}>
            <Routes>
              <Route
                path="/"
                element={
                  <PageTransition>
                    <Home />
                  </PageTransition>
                }
              />

              <Route
                path="/solucoes"
                element={
                  <PageTransition>
                    <Solucoes />
                  </PageTransition>
                }
              />

              <Route
                path="/product/:slug"
                element={
                  <PageTransition>
                    <ProductDetail />
                  </PageTransition>
                }
              />

              <Route
                path="/planos"
                element={
                  <PageTransition>
                    <Planos />
                  </PageTransition>
                }
              />

              <Route
                path="/planos/fazenda-leiteira"
                element={
                  <PageTransition>
                    <PlanosFazendaLeiteira />
                  </PageTransition>
                }
              />

              <Route
                path="/contato"
                element={
                  <PageTransition>
                    <Contact />
                  </PageTransition>
                }
              />

              <Route
                path="/privacidade"
                element={
                  <PageTransition>
                    <PoliticaPrivacidade />
                  </PageTransition>
                }
              />

              <Route
                path="/termos"
                element={
                  <PageTransition>
                    <TermosUso />
                  </PageTransition>
                }
              />
            </Routes>
          </main>

          <Footer />
          <ChatwootWidget />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;